// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconfont[data-v-52dcd701] {\n  margin-left: 5px;\n  font-size: 24px;\n  margin-top: -7px;\n  z-index: 1;\n  color: #bbbbbb;\n  margin-bottom: -7px;\n}\n.c_row-item[data-v-52dcd701] {\n  margin-bottom: 20px;\n}\n.color-box[data-v-52dcd701] {\n  width: 79%;\n}\n.color-box .color-item span[data-v-52dcd701] {\n  margin-left: 10px;\n  color: #1890ff;\n  font-size: 13px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
